import { type Event } from "../types/types.ts"

/**
 * What the delete/cancel dialog owes an organizer who has invited people.
 *
 * Deleting an appointment is not a private act once an invitation has gone
 * out: every attendee gets a cancellation that takes the meeting out of their
 * own calendar. Saying so is the difference between an informed decision and a
 * surprise the organizer has to apologise for.
 */
export const invitedAttendeeCount = (event?: Event | null): number => {
  const external = event?.external_participants?.length ?? 0
  const internal = event?.participants?.length ?? 0
  return external + internal
}

export const attendeeCancellationNotice = (
  event?: Event | null
): string | null => {
  const count = invitedAttendeeCount(event)
  if (!count) return null
  return count === 1
    ? "The invited attendee will be sent a cancellation, and this appointment will be removed from their calendar."
    : `All ${count} invited attendees will be sent a cancellation, and this appointment will be removed from their calendars.`
}
